export enum AppState{
    INIT = 0,
    LOADING,
    ERROR,
    LOGGEDIN,
    LOGGEDOUT,
    WIDGETS
}